export enum EditorLockType {
  Limit = 'limit',
  Ban = 'ban',
  Closed = 'closed',
  Unavailable = 'unavailable',
}
